import { FC } from 'react';

import S from './Loader.styled';

interface ILoaderProps {
  innerLoader?: boolean;
  loadingText?: string;
}

export const Loader: FC<ILoaderProps> = ({ innerLoader, loadingText }) => {
  return (
    <S.Wrapper innerLoader={innerLoader}>
      <S.Loader />
      {loadingText || ''}
    </S.Wrapper>
  );
};
